import { FONT_IMPORTS } from './font-imports';

function injectFontImports() {
  const styleElement = document.createElement('style');
  styleElement.textContent = FONT_IMPORTS;
  document.head.appendChild(styleElement);
}

document.addEventListener('DOMContentLoaded', injectFontImports);
